<template>
  <v-flex
    id="additionalParameters"
    class="question"
  >
    <h2 class="header">
      {{ $t('warehouses.additional_parameters.title') }}
    </h2>
    <ul class="questions-list">
      <li class="mt-4">
        <p class="header required">
          {{ $t('warehouses.additional_parameters.question_1') }}
        </p>
        <v-flex
          md3
          sm5
          xs8
        >
          <v-text-field
            v-model="size"
            v-validate="validationRules.get('warehouseSize')"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('warehouseSize')"
            :data-vv-as="' '"
            data-vv-name="warehouseSize"
            :suffix="'m2'"
            required
            :disabled="readOnly"
            inputmode="decimal"
          />
        </v-flex>
      </li>
      <li class="mt-4">
        <p class="header required">
          {{ question2.description }}
        </p>
        <v-radio-group
          v-model="hasInternet"
          v-validate="validationRules.get('warehouseHasInternet')"
          :error-messages="errors.collect('hasInternet')"
          :data-vv-as="' '"
          data-vv-name="hasInternet"
          required
        >
          <v-radio
            v-for="(item, index) in question2.resources"
            :key="index"
            :label="item.description"
            :value="item.id"
            :disabled="readOnly"
          />
        </v-radio-group>
        <p
          v-if="showQuestion2hint"
          class="font-weight-regular f-16"
        >
          {{ $t('warehouses.additional_parameters.no_internet_hint') }}
        </p>
      </li>
      <li class="mt-4">
        <p class="header required">
          {{ $t('warehouses.additional_parameters.question_3') }}
        </p>
        <ConfirmButtons
          v-model="truckAccess"
          v-validate="'required'"
          string
          :error-messages="errors.collect('truckAccess')"
          :data-vv-as="' '"
          :data-vv-name="'truckAccess'"
          :disabled="readOnly"
        />
      </li>
      <li class="mt-4">
        <p class="header required mb-0">
          {{ $t('warehouses.additional_parameters.question_4') }}
        </p>
        <a
          class="small"
          :href="links.SUPPORTING_WAREHOUSE_STANDARDS"
          target="_blank"
        >{{
          $t('warehouses.additional_parameters.standards')
        }}</a>
        <ConfirmButtons
          v-model="warehousePotential"
          v-validate="'required'"
          string
          :error-messages="errors.collect('warehousePotential')"
          :data-vv-as="' '"
          :data-vv-name="'warehousePotential'"
          class="mt-3"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="warehousePotential === 'yes'"
        class="mt-4"
      >
        <p class="header custom lA">
          {{ question4a.description }}
        </p>
        <v-checkbox
          v-for="(item, index) in question4a.resources"
          :key="index"
          v-model="warehouseEquipment"
          multiple
          :label="item.description"
          :value="item.id"
          :disabled="readOnly"
        />
      </li>
      <li class="mt-4">
        <p class="header required mb-0">
          {{ $t('warehouses.additional_parameters.question_5') }}
        </p>
        <ConfirmButtons
          v-model="needToCarryPackageUpstairs"
          v-validate="'required'"
          string
          :error-messages="errors.collect('needToCarryPackageUpstairs')"
          :data-vv-as="' '"
          :data-vv-name="'needToCarryPackageUpstairs'"
          class="mt-3"
          :disabled="readOnly"
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import validationRules from '@/constants/validationRules';
import links from '@/constants/links';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'warehouses/getAdditionalParametersField',
    mutationType: 'warehouses/updateAdditionalParametersField'
});

export default {
    name: 'AdditionalParameters',
    components: { ConfirmButtons },
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules,
            links
        };
    },
    computed: {
        ...mapFields([
            'size',
            'hasInternet',
            'truckAccess',
            'warehousePotential',
            'needToCarryPackageUpstairs',
            'warehouseEquipment'
        ]),
        resource () {
            return this.$store.getters['warehouses/getResource'];
        },
        question2 () {
            return this.resource.find((el) => el.id === 1001);
        },
        showQuestion2hint () {
            const question2Resource = this.question2.resources.find((el) => el.id === 323);
            return question2Resource ? this.hasInternet === question2Resource.id : false;
        },
        question4a () {
            return this.resource.find((el) => el.id === 1002);
        }
    }
};
</script>

<style scoped></style>
